import { Quote as QuoteIcon, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { QUOTES } from "../data/mock";
import { Reveal } from "./Reveal";

/*
 * Quote cards. Some quotes are long (up to ~10 lines), the card scales
 * the quote text down as it gets longer so the layout stays balanced.
 */
const sizeFor = (len) => {
  if (len < 90) return "text-xl md:text-[22px] leading-snug";
  if (len < 160) return "text-lg md:text-[19px] leading-snug";
  return "text-base md:text-[17px] leading-relaxed";
};

export const Quotes = () => {
  return (
    <section
      id="quotes"
      data-testid="quotes-section"
      className="py-24 md:py-32 px-6 md:px-12 lg:px-20"
      style={{
        background: "var(--brand-cream-soft)",
        borderTop: "1px solid var(--brand-line)",
        borderBottom: "1px solid var(--brand-line)",
      }}
    >
      <div className="max-w-6xl mx-auto">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-14">
            <h2
              className="text-4xl md:text-6xl font-bold tracking-tight"
              style={{ color: "var(--brand-ink)" }}
              data-testid="quotes-heading"
            >
              Quotes
            </h2>
            <p
              className="max-w-sm text-base leading-relaxed"
              style={{ color: "var(--brand-muted)" }}
            >
              Tap any quote to read the thinking behind it.
            </p>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5">
          {QUOTES.map((quote, i) => (
            <Reveal key={quote.id} delay={i * 0.05}>
              <Link
                to={`/quotes/${quote.slug}`}
                data-testid={`quote-card-${quote.id}`}
                className="group flex flex-col h-full text-left rounded-[20px] p-7 md:p-9 transition-all duration-300 hover:-translate-y-1"
                style={{
                  background: "var(--brand-cream)",
                  border: "1px solid var(--brand-line)",
                }}
              >
                <QuoteIcon
                  size={20}
                  strokeWidth={1.6}
                  className="mb-4"
                  style={{ color: "var(--brand-accent)" }}
                />
                <p
                  className={`${sizeFor(quote.text.length)} font-semibold tracking-tight flex-1`}
                  style={{ color: "var(--brand-ink)" }}
                >
                  &ldquo;{quote.text}&rdquo;
                </p>
                <span
                  className="mt-6 inline-flex items-center gap-1.5 text-sm font-semibold transition-colors duration-300"
                  style={{ color: "var(--brand-accent)" }}
                >
                  Read the meaning
                  <ArrowRight
                    size={15}
                    strokeWidth={2}
                    className="group-hover:translate-x-1 transition-transform duration-300"
                  />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
